import { render } from "./Main.vue?vue&type=template&id=54be4e22&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=54be4e22&lang=scss&scoped=true"

import exportComponent from "/home/islam/works/billing-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54be4e22"]])

export default __exports__